import React, {useState, useEffect, useCallback, useRef} from 'react';
import classNames from 'classnames';
import {useList} from 'react-use';
import PropTypes from 'prop-types';

import styles from './dropdown.module.css';
import team from "../../reducers/team";

function Dropdown(props) {
    const {title, options = [], selectedValues = [], onChange, getOptionLabel} = props;
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);
    const [list, { set, updateAt }] = useList([]);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);


    useEffect(() => {
        set(options.map(item => {
            const findData = selectedValues.find(value => value.id === item.id);
            return findData ?  { ...findData, active: true } : item;
        }));
    }, [options, selectedValues]);

    const onDropdownClick = useCallback((e) => {
        e.stopPropagation();
        setIsOpen(true);
    }, [isOpen]);

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    }, []);

    const onItemClick= useCallback((option, index) => {
        const item = {
            ...option,
            active: !option.active,
        };

        updateAt(index, item);
        onChange(item);
    }, [list]);
    return <div ref={wrapperRef} className={styles.dropdown} onClick={onDropdownClick}>
        <div className={styles.dropdownTitle}>
            {selectedValues.length === 0 && title}
            {
              selectedValues.map((team, index) => {
                    if((index === 0)){
                      return  team.team_name
                    }else{
                        return ',' + '  '+ team.team_name
                    }
            })}
        </div>
        <div className={classNames(styles.dropdownMenu, isOpen && styles.displayBlock)}>
            {list.map((option, idx) => {
                const label = getOptionLabel ? getOptionLabel(option, idx) : option.label;
                return <div key={idx} className={styles.dropdownMenuItem} onClick={() => onItemClick(option, idx)}>
                    <div style={{flex: 1}}>{label}</div>
                    <div className={classNames(styles.imageWrapper)}>
                        {option.active && <img src="/img/navigation/check_24px.svg" alt=""/>}
                    </div>
                </div>
            })}
        </div>
    </div>
}

Dropdown.propTypes = {
    title: PropTypes.string,
    options: PropTypes.array.isRequired,
    selectedValues: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    getOptionLabel: PropTypes.func,
};

export default Dropdown;
